module.exports = __webpack_public_path__ + "img/img30.a896b43f.svg";